import React, { useCallback, useContext, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { normalizeChannel, getDeviceForChannel } from '../../utils/responsive';
import { trackEvent } from '../../tracking';
import PageSections from '../../pages/PageSections';

export const NationalReviews = () => {
  const { slug, serviceId, page } = useParams();
  const { pathname, hash, search } = useLocation();

  const isContentfulPreview = pathname.includes('/contentPV/');
  const { channel } = useContext(ExperienceContext);
  const normalizedChannel = normalizeChannel(channel);
  const device = getDeviceForChannel(normalizedChannel);

  const serviceProps = {
    slug,
    serviceId,
    pageName: 'NationalReviews',
    isContentfulPreview,
    hashId: hash?.replace('#', ''),
    device,
    page,
    // Sorted and rating-filtered views carry ?sort / ?ratings and must not be
    // indexed. SEOMetadata reads this instead of window, so SSR agrees.
    search
  };

  const handleAnalyticsEvent = useCallback((eventInput, properties = {}) => {
    const pageContext = {
      page: 'NationalReviews',
      slug,
      ...(serviceId && { serviceId }),
      ...(page && { page }),
      timestamp: new Date().toISOString()
    };

    if (eventInput && typeof eventInput === 'object') {
      trackEvent(eventInput, { ...properties, ...pageContext });
      return;
    }

    trackEvent(eventInput, { ...properties, ...pageContext });
  }, [slug, serviceId, page]);

  useEffect(() => {
    trackEvent('Page Load', {
      name: 'NationalReviews',
      slug,
      ...(serviceId && { serviceId }),
      ...(page && { page }),
      timestamp: new Date().toISOString()
    });
  }, [slug, serviceId, page]);

  return (
    <PageSections serviceProps={serviceProps} trackEvent={handleAnalyticsEvent} />
  );
};

export default NationalReviews;
